import React from 'react';
import { connect } from 'react-redux';
import { DragDropContext } from 'react-beautiful-dnd';

import {
  Button,
  IconSettings,
  Modal,
  Card,
} from '@salesforce/design-system-react';
import Sidebar from '../../Components/Sidebars/App/Sidebar';
import Banner from '../../Components/App/Banner';
import PageBlockHeader from '../../Components/PageBlockHeader';
import EditColumn from '../../Components/ProductsOverlay/EditColumn';
import OverlayColumn from '../../Components/ProductsOverlay/OverlayColumn';
import FinishModal from '../../Components/App/FinishModal';
import ProductOverlayInstructions from '../../Components/Sidebars/Instructions/ProductOverlayInstructions';
import CustomToastContainer from '../../Components/App/CustomToastContainer';
import VidyardEmbed from '@vidyard/embed-code';
import ActiveCollabTile from '../../Components/ProductsOverlay/ActiveCollabTile';

import {
  updateMilestoneProductDB,
  updateMilestonePersonaDB,
  updateConnectorProductDB,
  updateConnectorPersonaDB,
  addQuipAccessToken,
  loadSalesforceProducts,
  updateJourneyCompleted,
  createQuip,
  addToast,
  createSlides,
  createStageMap,
  setSlidesLoading,
  setStageMapLoading,
} from './../../actions';

class ProductsOverlay extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isEditModalOpen: false,
      isFinishModalOpen: false,
      modalTitle: 'Edit',
      target: '',
      editContent: '',
      isAccordionOpen: false,
    };
  }

  toggleAccordionOpen = () => {
    if (this.state.isAccordionOpen === false) {
      this.setState({ isAccordionOpen: true });
    } else {
      this.setState({ isAccordionOpen: false });
    }
  };

  componentDidMount() {
    this.props.loadSalesforceProducts();
    // render all players from placeholder images in the document
    VidyardEmbed.api.renderDOMPlayers();
  }
  componentDidUpdate(prevProps) {
    if (prevProps.quipLink !== this.props.quipLink && this.props.quipLink) {
      window.open(this.props.quipLink, '_blank');
    }
  }
  toggleFinishModalOpen = () => {
    if(!this.props.journeyCompleted && !this.props.isCollaborator) {
      this.props.updateJourneyCompleted(this.props.journeyId);
    }

    this.setState({ isFinishModalOpen: !this.state.isFinishModalOpen });
  };

  closeModal = () => {
    this.setState({ isEditModalOpen: false });
  };

  generateQuip = () => {
    if (this.props.journeyId && this.props.quipAccessToken) {
      this.props.createQuip(this.props.quipAccessToken, this.props.journeyId);
    }
  };

  goToConnectors = () => {
    this.props.history.push('/ProductsOverlay');
    
    window.location.href = '/MilestoneConnectors';
  };

  /**
   *
   *
   *  START OF CLASS FUNCTIONS
   *
   *
   */

  onDragEnd = (result) => {
    const { destination, source, draggableId } = result;
    // if the destination is not one of the droppable regions, return early
    if (!destination) {
      return;
    }

    // split each id into an array for easier manipulation
    const splitDestinationId = destination.droppableId.split('-');
    const splitSourceId = source.droppableId.split('-');
    const splitDraggableId = draggableId.split('-');

    // get the last element of the draggableId
    // it will either be a product name or a persona id
    const item = splitDraggableId.slice(-1)[0];

    // we can figure out if it is a product or persona,
    // persona is a number(id) product is a string
    const isProduct = Number.isNaN(parseInt(item));

    // is the drag event coming from the EditBox / Edit Columns
    const isSourceEditColumn =
      source.droppableId !== 'droppable-product' &&
      source.droppableId !== 'droppable-persona';

    //if dragging item away from milestones/connectors
    // REMOVING from Persona / Products in EditBox
    if (isSourceEditColumn) {
      // Connector has 4 components for the source Id, Milestones have 3
      const isMilestone = splitSourceId.length === 3;

      const sourceId = parseInt(splitSourceId.slice(-1)[0]);
      const stageName = splitSourceId[1];

      //if it's a product
      if (isProduct) {
        if (isMilestone) {
          // This is a milestone

          const { productIds } = this.props.milestones[stageName];
          // REMOVING A PRODUCT, return all the productIds that DON'T match

          const newProductIds = productIds.filter(
            (productId) => productId !== item
          );
          this.props.updateMilestoneProductDB(
            stageName,
            sourceId,
            newProductIds
          );
        } else {
          // this is a connector
          const { productIds } = this.props.milestoneConnectors[stageName][
            sourceId
          ];

          const newProductIds = productIds.filter(
            (productId) => productId !== item
          );
          this.props.updateConnectorProductDB(
            stageName,
            sourceId,
            newProductIds
          );
        }
      }

      //if it's a persona
      else {
        if (isMilestone) {
          // REMOVING A PERSONA, return all the productIds that DON'T match
          const { personaIds } = this.props.milestones[stageName];
          const newPersonaIds = personaIds.filter(
            (personaId) => personaId !== item
          );
          this.props.updateMilestonePersonaDB(
            stageName,
            sourceId,
            newPersonaIds
          );
        } else {
          // connectors
          const { personaIds } = this.props.milestoneConnectors[stageName][
            sourceId
          ];

          const newPersonaIds = personaIds.filter(
            (personaId) => personaId !== item
          );
          this.props.updateConnectorPersonaDB(
            stageName,
            sourceId,
            newPersonaIds
          );
        }
      }
    }

    //if dragging item TOWARDS milestones/connectors
    // adding a product or persona to a connector or a milestone
    // use DestinationId for most things
    else {
      // Connector has 4 components for the draggable Id, Milestones have 3
      const isMilestone = splitDestinationId.length === 3;
      // get the DB id of the connector / milestone
      const targetId = parseInt(splitDestinationId.slice(-1)[0]);
      // get the milestone name
      const stageName = splitDestinationId[1];

      if (Number.isNaN(targetId)) {
        return;
      }
      if (isProduct) {
        //if dragging product
        if (isMilestone) {
          const { productIds } = this.props.milestones[stageName];
          // only add it if it doesn't already exist
          if (!productIds.includes(item)) {
            // if the product doesn't already exist, add it to the array
            const newProductIds = [...productIds, item];
            this.props.updateMilestoneProductDB(
              stageName,
              targetId,
              newProductIds
            );
          }
        } else {
          // its a connector, find the connector productIds
          const { productIds } = this.props.milestoneConnectors[stageName][
            targetId
          ];
          if (!productIds.includes(item)) {
            // if the product doesn't already exist, add it to the array
            const newProductIds = [...productIds, item];
            this.props.updateConnectorProductDB(
              stageName,
              targetId,
              newProductIds
            );
          }
        }
      } else {
        // not a product
        if (isMilestone) {
          // Check if Already in the array
          const { personaIds } = this.props.milestones[stageName];
          if (!personaIds.includes(item)) {
            const newPersonaIds = [...personaIds, item];
            this.props.updateMilestonePersonaDB(
              stageName,
              targetId,
              newPersonaIds
            );
          }
        } else {
          // connector
          const { personaIds } = this.props.milestoneConnectors[stageName][
            targetId
          ];
          // only add it if it doesn't already exist
          if (!personaIds.includes(item)) {
            const newPersonaIds = [...personaIds, item];
            this.props.updateConnectorPersonaDB(
              stageName,
              targetId,
              newPersonaIds
            );
          }
        }
      }
    }
  };

  render() {
    return (
      <IconSettings iconPath="/icons">
        <CustomToastContainer />
        <DragDropContext onDragEnd={this.onDragEnd}>
          <div className="outer-container">
            <Sidebar 
              stage="Product Overlays"
              instructions={<ProductOverlayInstructions />}
            />
            <Banner 
              backgroundColor='#D8E6FE'
              previous={this.goToConnectors}
              stage="Product Overlays"
              backgroundImage='/Images/Banners/HeroBanners-04.png'
            />
            <div>
            <div style={{ marginLeft: 'max(210px, 15%)'}}>
              <div className="slds-p-horizontal_x-large slds-p-vertical_medium">
                <Card
                  header={
                    <div className="slds-grid" style={{ width: '100%'}}>
                      <div className="slds-size_2-of-2">
                        <PageBlockHeader 
                          hasBorder={false} 
                          title="Overlay " 
                          addtl="Salesforce Products"
                          subtitle={`Step 1: Drag & Drop Products and Personas. Step 2: Generate Output.`}
                        />
                      </div>
                      <ActiveCollabTile />
                    </div>
                    
                  }
                  className="slds-p-horizontal_medium slds-m-top_x-small slds-p-top_xx-small"
                >
                  <div className="slds-grid">
                    <div
                      className={
                        this.props.isCollaborator
                          ? 'slds-size_3-of-3 slds-p-left_large'
                          : 'slds-size_2-of-3 slds-p-left_large'
                      }
                      style={{
                        overflowY: 'scroll',
                        maxHeight: '800px',
                        overflowX: 'hidden',
                      }}
                    >
                      <EditColumn
                        isCollaborator={this.props.isCollaborator}
                        products={this.props.products}
                        personas={this.props.personas}
                        milestones={this.props.milestones}
                        milestoneConnectors={this.props.milestoneConnectors}
                      />
                    </div>
                    {!this.props.isCollaborator ? (
                      <div
                        className="slds-size_1-of-3"
                        style={{ backgroundColor: '#efefef' }}
                      >
                        <OverlayColumn
                          products={this.props.products}
                          personas={this.props.personas}
                        />
                      </div>
                    ) : (
                      ''
                    )}
                  </div>
                </Card>
                <div
                  style={{ paddingLeft: '28.5%' }}
                  className="slds-m-top_medium slds-p-right_xx-large"
                >
                  <Button
                    label="Finish Journey"
                    variant="brand"
                    onClick={this.toggleFinishModalOpen}
                    className="slds-p-horizontal_medium"
                  />
                </div>
              </div>
            </div>
          </div>

            {/** Edit Content */}
            <Modal
              heading="Generate Output"
              size="small"
              isOpen={this.state.isFinishModalOpen}
              onRequestClose={this.toggleFinishModalOpen}
            >
              <FinishModal
                generateQuip={this.generateQuip}
                error={this.props.quipError}
                journeyId={this.props.journeyId}
                isLoading={this.props.isQuipLoading}
                quipToken={this.props.quipAccessToken}
                onQuipChange={(e) =>
                  this.props.addQuipAccessToken(e.target.value)
                }
                journeyEmail={this.props.journeyEmail}
                addToast={this.props.addToast}
                isSlidesLoading={this.props.isSlidesLoading}
                setSlidesLoading={this.props.setSlidesLoading}
                createSlides={this.props.createSlides}
                isStageMapLoading={this.props.isStageMapLoading}
                setStageMapLoading={this.props.setStageMapLoading}
                createStageMap={this.props.createStageMap}
                isCollaborator={this.props.isCollaborator}
              />
            </Modal>
          </div>
        </DragDropContext>
      </IconSettings>
    );
  }
}

const mapStateToProps = (state) => ({
  journeyId: state.app.journeyId,
  journeyEmail: state.app.username,
  journeyCompleted: state.app.journeyCompleted,
  isCollaborator: state.collaborators.isCollaborator,
  milestones: state.milestones,
  milestoneConnectors: state.milestoneConnectors,
  personas: state.personas,
  products: state.products,
  quipLink: state.quip.link,
  quipAccessToken: state.quip.accessToken,
  isQuipLoading: state.quip.isLoading,
  isSlidesLoading: state.app.isLoadingSlides,
  isStageMapLoading: state.app.isLoadingStageMap,
  quipError: state.quip.errorMessage,
});

const mapDispatchToProps = (dispatch) => ({
  addQuipAccessToken: (quipAccessToken) =>
    dispatch(addQuipAccessToken(quipAccessToken)),
  updateMilestoneProductDB: (stageName, id, products) =>
    dispatch(updateMilestoneProductDB(stageName, id, products)),
  updateMilestonePersonaDB: (stageName, id, personas) =>
    dispatch(updateMilestonePersonaDB(stageName, id, personas)),
  updateConnectorProductDB: (connectorName, id, products) =>
    dispatch(updateConnectorProductDB(connectorName, id, products)),
  updateConnectorPersonaDB: (connectorName, id, personas) =>
    dispatch(updateConnectorPersonaDB(connectorName, id, personas)),
  loadSalesforceProducts: () => dispatch(loadSalesforceProducts()),
  updateJourneyCompleted: (journeyId) =>
    dispatch(updateJourneyCompleted(journeyId)),
  createQuip: (quipToken, journeyId) =>
    dispatch(createQuip(quipToken, journeyId)),
  addToast: (toast) => dispatch(addToast(toast)),
  createSlides: (logo, email, journeyId, primaryColor, secondaryColor, type) =>
    dispatch(createSlides(logo, email, journeyId, primaryColor, secondaryColor, type)),
  setSlidesLoading: (isLoading) => dispatch(setSlidesLoading(isLoading)),
  setStageMapLoading: (isLoading) => dispatch(setStageMapLoading(isLoading)),
  createStageMap: (logo, email, journeyId, type) =>
    dispatch(createStageMap(logo, email, journeyId, type)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ProductsOverlay);
